<template>
    <div>
        <section class="assessmentSection orderCompleteSection checkoutSection">
            <div class="checkoutContainer">
                <div class="checkoutBody">
                    <div class="checkoutOverview">
                        <div class="orderCompleteTitle">Success!
                            <br> Now time to schedule your install.</div>
                        <h2 class="checkoutTitle">Scheduling your install.</h2>
                        <section class="orderConfirmationSection">
                            <div class="orderConfirmationLabel">Confirmation code</div>
                            <div class="orderConfirmationCode">{{ order.uuid }}</div>
                            <div class="orderConfirmationMessage">
                                <b>We will be contacting you shortly...</b> Haven’t heard from us yet? <span class="bold">Call in {{ supportNumber }}</span>
                            </div>
                            <div class="orderConfirmationMessage">
                                We also sent a confirmation email to <i>{{ lead.email }}</i>
                            </div>
                        </section>
                    </div>
                    <CheckoutSummary />
                </div>
            </div>
        </section>

        <section class="orderCompleteBottomSection">
            <div class="checkoutContainer">
                <section class="checkoutMonitoring">
                    <br>
                    <h2 class="checkoutTitle">What to expect.</h2>

                    <p>
                        Installation is scheduled over the phone. We believe there are 3 things that make a successfull installation.
                    </p>

                    <div class="schedulingChecklist padded">
                        <div class="schedulingChecklist-item">
                            <span class="key">1. Finding the right time for you.</span>
                        </div>
                        <div class="schedulingChecklist-item">
                            <span class="key">2. Providing the best support.</span>
                        </div>
                        <div class="schedulingChecklist-item">
                            <span class="key">3. Making sure you're happy!</span>
                        </div>
                    </div>

                    <p>
                        During your installation call, we will help you cover some important stuff. Here is a checklist.
                    </p>

                    <div class="schedulingChecklist">
                        <div class="schedulingChecklist-item">
                            <img src="/img/checkmark-gray.png"
                                 alt="Checkmark"
                                 class="schedulingChecklist-icon">
                            <span class="key">Set</span> a date and time.
                        </div>
                        <div class="schedulingChecklist-item">
                            <img src="/img/checkmark-gray.png"
                                 alt="Checkmark"
                                 class="schedulingChecklist-icon">
                            <span class="key">Confirm</span> your package and monitoring plan.
                        </div>
                        <div class="schedulingChecklist-item">
                            <img src="/img/checkmark-gray.png"
                                 alt="Checkmark"
                                 class="schedulingChecklist-icon">
                            <span class="key">Provide</span> emergency contact information.
                        </div>
                    </div>

                    <!-- <div class="afterChecklist">To schedule your install complete the checkout process.</div> -->

                </section>
            </div>
        </section>
    </div>
</template>



<script>
import { mapActions, mapState } from 'vuex'
import CheckoutSummary from './CheckoutSummary.vue'
export default {
    computed: {
        ...mapState(['order', 'lead', 'supportNumber'])
    },
    methods: {
        ...mapActions([]),
    },
    mounted() {
        let orderUUID = this.$route.query.confirmation
        gtag('event', 'conversion', {
            'send_to': 'AW-779887824/SpolCL2X3ZABENDJ8PMC',
            'transaction_id': orderUUID
        });
    },
    destroyed() {
        window.location = '/'
    },
    components: {
        CheckoutSummary
    },
}
</script>

<style lang="css"></style>
